import { Utilidades } from '@/Util/Utilidades';
import { Tarea } from '@/model/Tarea';
import { Traduccion, TraduccionFiltro } from '@/model/Traduccion';
import { TraduccionService } from '@/services/TraduccionService';
import Vue from 'vue'
import { Route } from 'vue-router';
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //API_ENDPOINT: "https://api.facturapp.apperos.com/",
    API_ENDPOINT: "",
    //DATE_FORMAT: "dd/mm/yyyy",
    // TokenExpiration: 10000,
    // SessionTimeout: 600000, //10 min
    Inactividad: 0,
    Login: null,
    usuario: "",
    traducciones: new Array<Object>() as Array<Traduccion>,
    tareas: new Array<Object>() as Array<Tarea>,
    page: "" as string,
    loading: false as boolean,
    interval: null,
    style: "currency",
    locale: 'es-ES',
    currency: 'EUR',
    ambiente: 'PRODUCCION',
    version: ""
  },
  getters: {
  },
  mutations: {
    setApiUrl(state, url) {
      state.API_ENDPOINT = url;
    },
    setTareas(state, tareas: Array<Tarea>) {
      state.tareas = tareas;
    },
    setPage(state, page: Route) {
      state.page = page.matched[page.matched.length - 1].path.split("/:")[0];
    },
    setTraducciones(state, traducciones: Array<Traduccion>) {
      state.traducciones = traducciones;
    },
    setTTareas(state, tareas: Array<Tarea>) {
      state.tareas = tareas;
    },
    setVersion(state, version) {
      state.version = version;
    },
    insertTraduccion(state, traduccion: Traduccion) {
      if (!state.traducciones)
        state.traducciones = new Array<Traduccion>();

      state.traducciones.push(traduccion);
    },
    insertTarea(state, tarea: Tarea) {
      if (!state.tareas)
        state.tareas = new Array<Tarea>();

      state.tareas.push(tarea);
    },
    updateTraduccion(state, datos: any) {
      state.traducciones[datos.index] = datos.datos;
    },
    updateTarea(state, datos: any) {
      state.tareas[datos.index] = datos.datos;
    },
    setLoading(state, loading: boolean) {
      state.loading = loading;
    },
    // setSessionTimeout(state, timeout: number) {
    //   state.SessionTimeout = timeout * 60000;
    //   //state.SessionTimeout = 10000; //10s
    // },
    setInactividad(state) {
      state.Inactividad = 0;

      if (state.interval) {
        state.interval.terminate();
        state.interval = null;
      }
      if (typeof Worker !== "undefined") {
        state.interval = new Worker("/Counter.js");
        state.interval.addEventListener("message", (e) => {
          state.Inactividad = state.Inactividad + 1000
        });
      } else {
        console.log("No hay suporte");
      }
    },
    // setSessionExpiration(state, exp: number) {
    //   state.Inactividad = 0;      

    //   if (state.interval) {
    //     state.interval.terminate();
    //     state.interval = null;
    //   }
    //   if (typeof Worker !== "undefined") {
    //     state.interval = new Worker("/Counter.js");        
    //     state.interval.addEventListener("message", (e) => {
    //       state.Inactividad = state.Inactividad + 1000          
    //     });
    //   } else {
    //     console.log("No hay suporte");
    //   }
    // },
    stopTokenVerification(state) {
      state.Inactividad = 0;
      // state.TokenExpiration = 1000;
      // state.SessionTimeout = 30000;

      clearInterval(state.interval);
    },
    setAmbiente(state, ambiente) {
      state.ambiente = ambiente;
    }
  },
  actions: {
    async loadTareasYTraduccion({ commit }) {
      try {
        var filtro = new Object() as TraduccionFiltro;
        filtro.pagina = this.state.page;

        if (Utilidades.isNullOrUndefinedOrEmpty(this.state.page))
          return;

        await TraduccionService.getTraduccionesYTareas(filtro)
          .then(x => {
            commit('setTraducciones', x.data.traducciones)
            commit('setTTareas', x.data.tareas)
          })
          .catch(() => { });
      } catch {
      }
    }
  },
  modules: {
  }
})
